<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Dashboard</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <h2>Latest Releases</h2>
        <b-list-group>
          <router-link v-for="(release, index) in releases" :key="release.id"
                       :to="{ name: 'ReleaseInspector', params: { version: release.version, app: release.app}}" custom v-slot="{ href}">
            <b-list-group-item class="flex-column align-items-start list-group-item-action" :href="href">
              <div class="d-flex w-100 justify-content-between align-items-center">
                <h5>{{ release.id }} <b-badge v-if="index === 0">NEW</b-badge></h5> <small>{{new Date(release.date).toLocaleString() }}</small>
              </div>
              <b-button-group>
                <b-button @click="deleteRelease($event, release, index)" variant="danger">Delete</b-button>
                <b-button @click="unlistRelease($event, index)" :pressed="release.listed"
                          :variant="(release.listed)? 'success' : 'secondary'">
                  <span v-if="release.listed">Listed</span><span v-else>Unlisted</span>
                </b-button>
              </b-button-group>
            </b-list-group-item>
          </router-link>

        </b-list-group>
      </b-col>
      <b-col md="6">
        <h2>Helpful Data</h2>
        <b-list-group>
          <b-list-group-item class="d-flex justify-content-between align-items-center" :href="firefoxUpdateURL">
            Firefox-Update Manifest
            <font-awesome-icon
                icon="clipboard"
                @click="toClipboard($event, firefoxUpdateURL)"
            ></font-awesome-icon>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">API-Key: <span>{{ apiKeyHidden }}</span><font-awesome-icon
              icon="clipboard"
              @click="toClipboard($event, apiKey)"
          ></font-awesome-icon></b-list-group-item>
        </b-list-group>
        <h2 class="mt-4">Discovered Apps</h2>
        <b-list-group>
          <b-list-group-item v-for="(value, propertyName) in discoveredApps" :key="propertyName">
            {{ propertyName }} with {{ value.releases.length }} releases on record
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "MainView",
  data() {
    return {
      releases: [],
      baseURL: process.env.VUE_APP_API,
      apiKey: '',
    }
  },
  created() {
    fetch("/web/releases")
    .then(body =>  body.json())
    .then(data => {
      data.sort((a,b) => b.date - a.date)
      this.releases = data
    })
    fetch("/web/apikey")
    .then(body => body.json())
    .then(data => this.apiKey = data.apikey)
  },
  computed: {
    firefoxUpdateURL() {
      return this.baseURL + "/api/2.0/firefox_updates.json"
    },
    discoveredApps() {
      let rc = {  }
      this.releases.forEach(release => {
        if(rc[release.app] == null) rc[release.app] = { releases: [] }
        rc[release.app].releases.push(release)
      })
      return rc
    },
    apiKeyHidden() {
      let masked = ''
      for(let i = 0; i < this.apiKey.length; i++) {
        masked += '*'
      }
      return masked
    }
  },
  methods: {
    toClipboard(event, url) {
      event.preventDefault()
      navigator.clipboard.writeText(url)
      .then(() => {
        this.$bvToast.toast("Data is copied to your Clipboard!", {
          title: 'Copied!',
          autoHideDelay: 2000,
          appendToast: false,
          variant: 'success'
        })
      })
    },
    unlistRelease(event, index) {
      let release = this.releases[index]
      event.preventDefault()
      fetch(`/web/unlist/${release.app}/${release.version}`, {
        method: "PUT"
      }).then(body => body.json())
      .then(data => release.listed = data.newVal)
    },
    deleteRelease(event, release, index) {
      event.preventDefault()
      this.$bvModal.msgBoxConfirm(`Please confirm you want to delete the release ${release.id}`, {
        title: 'Please confirm',
        okVariant: 'danger'
      })
      .then(value => {
        if(value) {
          fetch(`/api/2.0/release/${release.app}/${release.version}`, {
            method: "DELETE"
          }).then(res => {
            if(res.status === 200) this.releases.splice(index, 1)
            else {
              this.$bvToast.toast("This entry could not be deleted, please reload the page", {
                title: 'Error!',
                autoHideDelay: 5000,
                appendToast: false,
                variant: 'danger'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>